import { Card, Col } from "react-bootstrap";
import { processData } from '../../DynamicData/ProcessData'
import { Aspects } from '../../DynamicData/Aspects'
import { Accordion, AccordionSummary, AccordionDetails, Typography } from '@mui/material';
import { ExpandMore } from '@mui/icons-material'
import businessStrategy from '../../assets/business-strategy.svg'
import letsStart from '../../assets/lets-start.svg'
import nextLevel from '../../assets/next-level.svg'
import AreaData from "../../DynamicData/AreaData";
import OurTeam from '../Commen/OurTeam'

const Info = () => {
    return (
        <>
            <div id="about" className="info-section bg-light position-relative overflow-hidden p-3 p-md-3 text-justify">
                <div className="col-md-11 px-lg-5 px-md-2 px-sm-2 p-lg-5 mx-auto d-flex flex-column justify-content-center my-5 fw-bold">
                    <div className="col-md-9 mx-auto">
                        <h2 className="display-5 fw-bolder mb-4 text-center text-danger info-title"
                            data-aos="zoom-in"
                            data-aos-duration="800">Best Our services represent what we are
                            Not what we do</h2>
                        <p className="lead fw-300 mb-3 info-desc para text-black"
                            data-aos="fade-up"
                            data-aos-duration="1000"
                            data-aos-delay="500">We have experienced personnel who always seek even the tiniest opportunities to help your brand to grow in terms of behavior, culture, technology, lifestyle, and commerce. Brands who want to progress will always have our support.</p>
                    </div>
                    <hr />

                    <div className="p-5 my-5 make-website rounded rounded-3 border shadow">
                        <h2 className="border-primary border-bottom mx-lg-5 text-center mb-3 text-primary make-website-title"
                            data-aos="fade-down"
                            data-aos-duration="1000"> Make Website Designing Easy With The Best Web Development Company in Nagpur</h2>
                        <p className="lead1 fw-normal mb-3 info-desc text-black"
                            data-aos="fade-right"
                            data-aos-duration="1000"
                            data-aos-delay="300">Bluecoder is among the top web development companies in Nagpur that can create different types of websites exactly as per customer’s requirements. When it comes to searching the best website design and development services in Nagpur and that at competitive prices, Bluecoder is the company that pops up in everyone’s mind. We offer dynamic, fast, and custom web design solutions that help our customers to become the game-changer in their respective markets.</p>
                        <p className="lead1 fw-normal mb-3 info-desc text-black"
                            data-aos="fade-left"
                            data-aos-duration="1000"
                            data-aos-delay="600">Our innovative professionals create engaging, unique, and creative websites that help your business to attract the right kind of customers. We create websites on various platforms, such as PHP, WordPress, React and Java that allow you to make changes in the content as per the changing trends in the market. With such flexibility, you can ensure that your website will always have the updated information that will make it rank at the top of search results. The platforms we use to create websites are safe and secure so that you can keep your mind at ease and focus on creating products that leave your customers awestruck.</p>
                    </div>
                    <img height="100%" width="100%" loading="lazy" src={businessStrategy} alt="Business_strategy" title="Business strategy"
                        data-aos="zoom-in"
                        data-aos-duration="600" />
                    <hr />
                    <div className="area">
                        <h2 className="pt-2 my-5 text-center"
                            data-aos="fade-down"
                            data-aos-duration="1000"> Areas of Expertise</h2>
                        <div className="row mx-auto mb-5 pb-5">
                            {AreaData.map((area) => (
                                <div className="col-lg-3 mx-auto text-center col-md-6 col-sm-12" key={area.id}>
                                    <div className="header d-flex flex-column justify-content-center align-items-center my-2 h-50">
                                        <img height="50%" width="50%" loading="lazy" src={area.img} alt={area.title + " Image"} title={area.title + " Image"}
                                            data-aos="zoom-in"
                                            data-aos-duration="1000"
                                            data-aos-delay="200" />
                                        <h3 className="text-center text-secondary"
                                            data-aos="fade-up"
                                            data-aos-duration="1000"
                                            data-aos-delay="400">{area.title}</h3>
                                    </div>
                                    <p className="lead text-success"
                                        data-aos="zoom-out"
                                        data-aos-duration="1000"
                                        data-aos-delay="600">{area.desc}</p>
                                </div>
                            ))}
                        </div>
                        <hr />
                        <div className="row mx-auto my-5">
                            <div className="col-lg-6 mx-auto px-5 text-center col-md-6 col-sm-12" >
                                <div className="header d-flex flex-column justify-content-center align-items-center my-2">
                                    <p className="lead fw-bold text-danger"
                                        data-aos="fade-right"
                                        data-aos-duration="1000">Confidence in Approach</p>
                                    <h3 className="text-center text-secondary"
                                        data-aos="fade-left"
                                        data-aos-duration="1000"
                                        data-aos-delay="300">START FROM THE BOTTOM</h3>
                                </div>
                                <p className="lead"
                                    data-aos="fade-up"
                                    data-aos-duration="1000"
                                    data-aos-delay="400">All big companies started somewhere, let’s build the future together.</p>
                                <div className="row my-5 d-flex justify-content-between align-items-center"
                                    data-aos="zoom-out"
                                    data-aos-duration="1000"
                                    data-aos-delay="600">
                                    <img height="auto" width="auto" loading="lazy" src={letsStart} alt="Start from the bottom" title="Start from the bottom" />
                                </div>
                            </div>
                            <div className="col-lg-6 mx-auto px-5 text-center col-md-6 col-sm-12" >
                                <div className="header d-flex flex-column justify-content-center align-items-center my-2">
                                    <p className="lead fw-bold text-danger"
                                        data-aos="fade-left"
                                        data-aos-duration="1000">Confidence in Approach</p>
                                    <h3 className="text-center text-secondary"
                                        data-aos="fade-right"
                                        data-aos-duration="1000"
                                        data-aos-delay="300">TAKE IT TO THE NEXT LEVEL</h3>
                                </div>
                                <p className="lead"
                                    data-aos="fade-up"
                                    data-aos-duration="1000"
                                    data-aos-delay="400">Helping established companies build their next big thing or just make things a little easier.</p>
                                <div className="row mt-5 d-flex justify-content-between align-items-center"
                                    data-aos="zoom-out"
                                    data-aos-duration="1000"
                                    data-aos-delay="600">
                                    <img height="100%" width="100%" loading="lazy" src={nextLevel} alt="Take it to the next level" title="Take it to the next level" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <hr />
                    <h3 className="fw-bold pt-2 mb-3 text-primary info-title make-website-title text-center"
                        data-aos="zoom-in"
                        data-aos-duration="1000"> What Makes Us The Best Website Designing Company in Nagpur?</h3>

                    <p className="fw-300 mb-3 info-desc text-warning lead1"
                        data-aos="fade-down"
                        data-aos-duration="1000"
                        data-aos-delay="400">As the best website designing company in Nagpur, our main aim is to provide you with a strong digital presence. Our customer-centric approach helps us to deliver websites that are creative, unique, and personalized to imprint a good impression on the mind of your customers. To have you a better understanding of our website designing process, here we are listing it out:</p>

                    <div className="row my-5 d-flex justify-content-center flex-wrap">
                        {processData.map((process) => (
                            <Col xs={10} md={6} lg={6} className="my-3" key={process.id}>
                                <Card className="cards" data-aos="flip-left" data-aos-duration="1000">
                                    <Card.Body className="process_card d-flex justify-content-center flex-column">
                                        <Card.Title className="service_title text-center">{process.icon}</Card.Title>
                                        <Card.Title className="service_title text-center">{process.service}</Card.Title>
                                        <Card.Text className="my-3 fw-100 process_desc service_desc">{process.desc}</Card.Text>
                                    </Card.Body>
                                </Card>
                            </Col>
                        ))}
                    </div>
                    <hr />

                    <h3 className="fw-bold mb-3 py-3 text-danger info-title make-website-title text-center"
                        data-aos="fade-left"
                        data-aos-anchor-placement="center-center">Why Choose Us As Your Website Designing Company in Nagpur?</h3>

                    <p className="lead1 mb-3 info-desc"
                        data-aos="fade-right"
                        data-aos-anchor-placement="center-center"
                        data-aos-delay="300">Your website represents your brand online, and definitely, you want it to be a good one. As a pre-eminent website designing company in Nagpur, we create stunning websites backed with search engine algorithms that can easily crawl to the top of SERPs. By choosing us as your partner in web designing, you can get yourself an amazing website that uniquely represents your business 24*7. If you are still wondering whether to choose us, we are here to mention some reasons that help you make a better choice.
                    </p>

                    {Aspects.map((aspect) => (
                        <Accordion className="shadow" key={aspect.id}>
                            <AccordionSummary
                                className="text-white bg-danger"
                                expandIcon={<ExpandMore className="text-white" />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography data-aos="fade">{aspect.title}</Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Typography className="lead1">
                                    {aspect.desc}
                                </Typography>
                            </AccordionDetails>
                        </Accordion>
                    ))}


                    <p className="lead1 fw-normal mt-3 info-desc text-black"
                        data-aos="fade-left">At Bluecoder, we follow all digital marketing ethics to make your brand a success on the internet-based platform. We put in all our efforts to deliver you a website that can promote your business every single second in the digital market. Our dedication, values, and hard work have made us the best website designing agency in Nagpur.
                    </p>

                </div>
                <div className="product-device shadow-sm d-none d-md-block"></div>
                <div className="product-device product-device-2 shadow-sm d-none d-md-block"></div>
            </div>
            {/* <OurTeam /> */}
        </>
    )
}

export default Info